import React, { useEffect, useState } from "react";

import cn from "classnames";
import styles from "./Front.module.sass";
import Help from "../../components/Sidebar/Help";
import Icon from "../../components/Icon";
import ImageC from "./Components/imageC";
import Loader from "../../components/Loader";
import cusHomePage from "../../i11/CustomizeHomePage";

import { UseApi } from "../../hooks/use-api";
import { useUser } from "../../context";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import { GetCollectionsSimple } from "../../Services/lib/nft";
import { GetBrand, UpdateBrand } from "../../Services/lib/brand";
import { GetBanner, GetCategoriesSimple } from "../../Services/lib/admin";

import BrandBoxNavbar from "./Components/navbar";
import BrandBoxFooter from "./Components/footer";
import CustomizeEditCategory from "./Components/category";
import CustomizePopularProducts from "./Components/PopularProducts";

const initialValState = {
	vals: [],
	dic: {},
};
export const listGenerator = (item) => {
	const newList = [];
	for (let i = 0; i < item; i++) newList.push(i);
	return newList;
};
const BrandBoxFrontHome = () => {
	const { locale } = useUser();

	const [banner, setBanner] = useState();
	const [saveButton, setSaveButton] = useState();
	const [visibleHelp, setVisibleHelp] = useState(false);

	const [categories, setCategories] = useState(initialValState);
	const [collections, setCollections] = useState(initialValState);
	const [homeVals, setVals] = useState({ title: "", description: "" });

	const [{ isLoading: titleUpLoading }, updateBrand] = UseApi({
		service: UpdateBrand,
		successMsg: "Success",
	});
	const [{ data: brandData, isLoading }, fetchBrand] = UseApi({
		service: GetBrand,
	});
	const [{}, GetCategory] = UseApi({
		service: GetCategoriesSimple,
	});
	const [{}, GetCollection] = UseApi({
		service: GetCollectionsSimple,
	});

	const [{ data, isLoading: loading }, getBanner] = UseApi({
		service: GetBanner,
	});

	const init = async () => {
		const res = await fetchBrand();
		if (res && res.paragraphs) {
			const {
				paragraphs: { home },
			} = res;
			home && setVals(home);
		}
		const categories_ = await GetCategory();
		if (categories_) {
			const dic = {};
			const vals = categories_.map((e) => {
				dic[e._id] = { title: e.title };
				return e._id;
			});
			setCategories({
				vals,
				dic,
			});
		}
		const conllections_ = await GetCollection();
		if (conllections_) {
			const dic = {};
			const vals = conllections_.map((e) => {
				dic[e._id] = { title: e.name };
				return e._id;
			});
			setCollections({
				vals,
				dic,
			});
		}
	};

	const open_ = (e) => {
		console.log(e);
		setVisibleHelp(true);
		const {
			_id,
			title,
			description,
			image,
			image_thumb,
			prior,
			url,
			banner_size,
		} = e;
		setBanner({
			_id,
			title,
			description,
			image,
			prior,
			image_thumb,
			url,
			banner_size,
		});
	};

	const updateTitleDesc = async () => {
		if (!homeVals.title.trim() || !homeVals.description.trim()) {
			ToastEmitter({
				msg: homeVals.title ? "Description empty!" : "Title empty!",
				type: "info",
			});
			return;
		}
		const result = await updateBrand({
			paragraphs: {
				...brandData?.paragraphs,
				home: homeVals,
			},
		});
		if (result) {
			setSaveButton(false);
		}
	};

	const handlerHomeText = (name, v) => {
		setSaveButton(true);
		setVals((val) => {
			return {
				...val,
				[name]: v.target.value,
			};
		});
	};
	useEffect(() => {
		getBanner();
		init();
	}, []);

	const props = {
		linksTo3: { Categories: categories, Collections: collections },
		getBanner: () => {
			getBanner();
			setVisibleHelp(false);
		},
	};

	return (
		<>
			<div className={styles.web}>
				<BrandBoxNavbar image={brandData?.image} name="home" />

				<div className={cn(styles.ph, styles.flex)}>
					{data?.map((e) => {
						return (
							<ImageC
								key={e._id}
								open={open_}
								halfSize={e.banner_size === "medium"}
								item={e}
								reload={getBanner}
							/>
						);
					})}
				</div>
				<br />
				<div className={styles.center}>
					{!loading && (
						<button
							className={cn("button-stroke button-small", styles.button)}
							onClick={() => {
								setBanner();
								setVisibleHelp(true);
							}}
						>
							<Icon name="add" size={24} />
							{cusHomePage[locale].add_banner}
						</button>
					)}
				</div>

				<div className={styles.center}>
					{isLoading ? (
						<Loader className={styles.mrAuto20} />
					) : (
						<div className={styles.homeTitle}>
							<input
								defaultValue={homeVals.title || ""}
								type="text"
								placeholder={cusHomePage[locale].place_h_title}
								onChange={(v) => handlerHomeText("title", v)}
							/>
							<textarea
								name="Description"
								placeholder={cusHomePage[locale].place_h_desc}
								defaultValue={homeVals.description || ""}
								onChange={(v) => handlerHomeText("description", v)}
								onKeyDown={(e) => {
									if (e.key === "Enter") {
										e.preventDefault();
									}
								}}
							/>
							{saveButton && (
								<button
									className={cn(
										"button-stroke button-small",
										styles.button,
										styles.mrAuto
									)}
									disabled={titleUpLoading}
									onClick={updateTitleDesc}
								>
									{titleUpLoading && <Loader />}
									{cusHomePage[locale].save}
								</button>
							)}
							<div className={styles.bottomDesc}>
								{cusHomePage[locale].customize_text}
							</div>
						</div>
					)}
					<CustomizePopularProducts />
					<CustomizeEditCategory />
					<BrandBoxFooter />
				</div>
				{visibleHelp && (
					<Help
						visible={visibleHelp}
						setVisible={setVisibleHelp}
						onClose={() => {
							setBanner();
							setVisibleHelp(false);
						}}
						editItem={banner}
						props={{ ...props }}
					/>
				)}
			</div>
		</>
	);
};

export default BrandBoxFrontHome;
